<script setup>
import { useProjectStore } from '@/store/project'
import ProjectPage from '@/components/views/ProjectPage.vue'

const { project: projectSlug } = useRoute().params

const projectStore = useProjectStore()

const { fetchProject } = projectStore

if (!projectStore.project || projectStore.project.slug !== projectSlug) {
    await fetchProject(projectSlug)
}

const project = projectStore.project

if (project) {
    useSeoMeta({
        title: `${project.name} - Visuado`,
        ogTitle: project.name,
        description: project.description,
        ogDescription: project.description
    })
}
</script>
<template>
    <ProjectPage />
</template>
